import React from "react";

const VARIANT_CLASSES = {
  primary:
    "bg-primary text-white shadow-sm shadow-primary/30 hover:brightness-95 focus-visible:ring-primary/40",
  secondary:
    "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 focus-visible:ring-slate-400/40",
  ghost:
    "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 dark:bg-slate-800/60 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800 focus-visible:ring-slate-400/40",
  danger:
    "bg-rose-50 text-rose-600 hover:bg-rose-100 dark:bg-rose-500/10 dark:text-rose-300 dark:hover:bg-rose-500/20 focus-visible:ring-rose-400/40",
};

const SIZE_CLASSES = {
  sm: "text-xs px-3 py-2 rounded-lg gap-1.5",
  md: "text-sm px-5 py-2.5 rounded-xl gap-2",
  lg: "text-base px-6 py-3 rounded-xl gap-2.5",
};

// Shared button primitive — variants/sizes cover every hand-rolled button
// style found across Admin_page.jsx (save/cancel/close/logout) so future
// screens can consume one component instead of re-styling per screen.
export default function Button({
  variant = "primary",
  size = "md",
  icon: Icon,
  iconOnly = false,
  loading = false,
  disabled = false,
  type = "button",
  className = "",
  children,
  ...rest
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-4 disabled:opacity-60 disabled:cursor-not-allowed ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} ${iconOnly ? "!px-0 aspect-square" : ""} ${className}`}
      {...rest}
    >
      {loading ? (
        <span
          className="h-4 w-4 rounded-full border-2 border-current border-t-transparent animate-spin"
          aria-hidden="true"
        />
      ) : Icon ? (
        <Icon className={iconOnly ? "text-lg" : "text-base"} aria-hidden="true" />
      ) : null}
      {!iconOnly && children}
    </button>
  );
}
